import { useStateStore } from '../../stores/useStateStore';

export const useUsers = () => useStateStore((state) => state.users);
